






























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import lax from "lax.js";

@Component
export default class SectionHeroScroller extends Vue {
    @Prop({ default: "" }) title?: string;

    @Prop({ default: "" }) description?: string;

    @Prop({ default: false }) showBreadcrumbs?: boolean;

    @Prop({ default: "" }) pageTitle?: string;

    @Prop({ default: "" }) gtmClass?: string;

    @Prop() items: any;

    @Prop() links: any;

    step_count: number = 0;

    screen_height: number = 900;

    half_screen_height: number = 0;

    screen_multiplier: number = 0.6;

    step: number = 0;

    mounted() {
        this.step_count = Object.keys(this.items).length;
        this.screen_height = window.innerHeight;
        this.half_screen_height = this.screen_height / 2;
        this.$nextTick(function() {
            this.$nextTick(function() {
                setTimeout(() => {
                    this.initLax();
                }, 200);
            });
        });
    }

    private initLax() {
        lax.init();

        lax.addDriver("scrollY", function() {
            return window.scrollY;
        });

        lax.addElements(".selector-c", {
            scrollY: {
                translateY: [
                    [0, "pageHeight"],
                    [1, "-elHeight"]
                ]
            }
        });

        let secondToLastStep = (this.step_count - 1) * (this.screen_height / 2);
        const eFader = [0, (this.step_count - 1) * (this.screen_height / 2), secondToLastStep + this.screen_height / 2];

        lax.addElements(".selector-e", {
            scrollY: {
                opacity: [eFader, [1, 1, 0.8]],
                translateY: [eFader, [0, 0, -this.screen_height / 2]]
            }
        });

        lax.addElements(".selector-f", {
            scrollY: {
                opacity: [eFader, [1, 1, 0]]
            }
        });

        lax.addElements(".selector-word", {
            scrollY: {
                opacity: [
                    ["elInY+120", "elCenterY", "elOutY-200"],
                    [0, 1, 1]
                ]
            }
        });

        let opacityStepMap = [0];
        let opacityMap = [1];

        for (let i = 1; i <= this.step_count; i++) {
            opacityStepMap.push(this.half_screen_height * i - this.half_screen_height / 2 - 100);
            opacityStepMap.push(this.half_screen_height * i - this.half_screen_height / 2);
            opacityStepMap.push(this.half_screen_height * i - this.half_screen_height / 2 + 100);

            opacityMap.push(1);
            opacityMap.push(0.2);
            opacityMap.push(1);
        }

        lax.addElements(".selector-text", {
            scrollY: {
                opacity: [opacityStepMap, opacityMap]
            }
        });
    }

    get scrollableHeightStyle() {
        return { height: `${this.step_count * (this.screen_height * this.screen_multiplier)}px` };
    }

    scrollTo(index: number) {
        window.scrollTo({
            top: (this.screen_height / 2) * index,
            left: 0,
            behavior: "smooth"
        });
    }

    created() {
        window.addEventListener("scroll", this.handleScroll);
    }

    destroyed() {
        lax.removeDriver("scrollY");

        window.removeEventListener("scroll", this.handleScroll);
    }

    private handleScroll() {
        this.step = Math.round(window.scrollY / this.half_screen_height);
    }

    get filteredItems() {
        return this.items.map((item: any) => {
            const str_split: string[] = item.caption.split("{e}");
            return {
                ...item,
                part_left: str_split[0],
                part_right: str_split[1]
            };
        });
    }
}
